import React from 'react'
import skillImage from '../../assets/images/hr/undraw06.svg'
import skillImage1 from '../../assets/images/hr/undraw07.svg'
import skillImage2 from '../../assets/images/hr/undraw08.svg'
import skillImage3 from '../../assets/images/hr/undraw09.svg'

function SkillSection() {
    return (
        <React.Fragment>
            {/* Background Pattern from Toptal Subtle Patterns */}
            <div className="container-box" id="recruitHR-skills-container">
                <div className="row">
                    <div className="col skill-image1">
                        <img  src={skillImage} alt="skills-illustration" />
                    </div>
                    <div className="col">
                        <h1>システムを作るのはCPUではないヒトのココロだ!</h1>
                        <p>
                            システム構築において求められるのは効率や整合性・機能性です。<br/>
                            しかし私たちは、それらを生み出すものとして、むしろ「計算できない気持ち」を重要視します。<br/>
                            お客様の課題に最も応えられる可能性を常に積極的に考え、取り入れていく。<br/>
                            システムを作る者として、むしろ重要なのはアイデアと熱意であると、私たちは考えます。<br/>
                        </p>
                    </div>
                </div>
            </div>
            <div className="container-box" id="recruitHR-skill-list-container">
                <div className="row">
                    <div className="col col-sm-12 col-md-4 skill-list-card">
                        <div className="skill-image">
                            <img src={skillImage1} alt="skills-illustration" />
                        </div>
                        <div className="skill-sub-header">
                            <h5>仕事はアツく、冷静に</h5>
                        </div>
                        <div className="skill-content">
                            <p> お客様に喜んでもらうために、NALは常にニーズよりもワンランク上のソリューションを目指しています。 
                                そのためには、仕組みに穴がないか冷静に見極める目と、仕組みで世界をかえてやろうという熱意が大事。
                                知識は後からついてきます。冷静にアツくなれる人材をNALは求めます。
                            </p>
                        </div>
                    </div>
                    <div className="co col-sm-12 col-md-4 skill-list-card">
                        <div className="skill-image">
                            <img src={skillImage2} alt="skills-illustration" />
                        </div>
                        <div className="skill-sub-header">
                            <h5>コミュニケーションがイイシゴトを生む</h5>
                        </div>
                        <div className="skill-content">
                            <p> システム制作はプロジェクトワークです。一人で完結できるものではありません。
                                むしろ周りのスタッフのポテンシャルを最大限引き出すことが重要です。 
                                先輩と議論を活発にしてください。そこから本当のソリューションは生まれます。
                            </p>
                        </div>
                    </div>
                    <div className="col col-sm-12 col-md-4 skill-list-card">
                        <div className="skill-image">
                            <img src={skillImage3} alt="skills-illustration" />
                        </div>
                        <div className="skill-sub-header">
                            <h5>アンテナを敏感に張り巡らせる</h5>
                        </div>
                        <div className="skill-content">
                            <p> 私たちのビジネスフィールドは、日進月歩で発展するインターネットの世界です。
                                常に新しいサービス、世の中の流れをキャッチすることが重要です。
                                社会にアンテナを立ててください。新しい知識を貪欲に取り入れチャレンジしていきましょう。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default SkillSection
